export const livre = {
  isbn: "K782765073871",
  titre: "Terminus",
  sousTitre:
    "Parcours interactif <span class='heading-subtitle__dot'>■</span> 4<sup>e</sup> année",
  startAudio: "7670_terminus_audio_ParcoursInteractifDepart_220826_v01",
  stopAudio: "7670_terminus_audio_ParcoursInteractifArrivee_220826_v01",
  certificat:
    "https://www.iplusinteractif.com/contenus-statiques/parcours-interactif/terminus4/storage/K782765073871/Parcours_interactif_Passeport_Terminus4.pdf",
  certificatDownloadText: "Télécharger le passeport",
};

export const chapitres = [
  {
    id: 1,
    titre: "Expédition <span class='chapter-number'>1</span>",
    sousTitre:
      "La <span class='chapter-emphasis'>Nouvelle-France</span> vers 1645",
    pauses: [
      {
        id: 1,
        contenus: [
          {
            type: "audio",
            titre: "Audio",
            url: "7670_terminus4_audio_1-1_vasco_220315_v01",
            texte: "1.1 Vasco de Gama",
          },
          {
            type: "video",
            titre: "Vidéo",
            url: "692258132",
            texte: "1.1 Les débuts de la colonie",
          },
          {
            type: "interactif",
            titre: "Clic info !",
            url: "https://www.iplusinteractif.com/dapps/criterie/87/",
            texte: "1.1 Les maisons des premiers colons en Nouvelle-France",
          },
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_1_1/Activity/",
            texte: "1.1 Halte ! (Stations 1 à 3)",
          },
        ],
      },
      {
        id: 2,
        contenus: [
          {
            type: "audio",
            titre: "Audio",
            url: "7670_terminus4_audio_1-2_scene_troc_220302_v03",
            texte: "1.2 Une scène de troc",
          },
          {
            type: "video",
            titre: "Vidéo",
            url: "718772583",
            texte: "1.2 Les métiers en Nouvelle-France",
          },
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_1_2/Activity/",
            texte: "1.2 Halte ! (Stations 4 à 6)",
          },
        ],
      },
      {
        id: 3,
        contenus: [
          {
            type: "audio",
            titre: "Audio",
            url: "7670_terminus4_audio_1-3_Bourgeoys_220513_v01",
            texte: "1.3 Marguerite Bourgeoys",
          },
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_1_3/Activity/",
            texte: "1.3 Halte ! (Stations 7 à 9)",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    titre: "Expédition <span class='chapter-number'>2</span>",
    sousTitre:
      "La <span class='chapter-emphasis'>Nouvelle-France</span> entre 1645 et 1745",
    pauses: [
      {
        id: 1,
        contenus: [
          {
            type: "interactif",
            titre: "Clic info !",
            url: "https://www.iplusinteractif.com/dapps/criterie/107/",
            texte:
              "2.1 Les vêtements et les accessoires des miliciens et des&nbsp;soldats",
          },
          {
            type: "audio",
            titre: "Audio",
            url: "7670_terminus4_audio_2-1_Talon_Pete_220324_v02",
            texte: "2.1 Jean Talon",
          },
          {
            type: "video",
            titre: "Vidéo",
            url: "710817089",
            texte: "2.1 Les Filles du Roy",
          },
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_2-1/Activity/",
            texte: "2.1 Halte ! (Stations 10 et 11)",
          },
        ],
      },
      {
        id: 2,
        contenus: [
          {
            type: "audio",
            titre: "Audio",
            url: "7670_terminus4_audio_2-2_Hocquart_220527_v02",
            texte: "2.2 Gilles Hocquart",
          },
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_2_2/Activity/",
            texte: "2.2 Halte ! (Stations 12 et 13)",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    titre: "Expédition <span class='chapter-number'>3</span>",
    sousTitre:
      "La <span class='chapter-emphasis'>Nouvelle-France</span> vers 1745",
    pauses: [
      {
        id: 1,
        contenus: [
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_3_1/Activity/",
            texte: "3.1 Halte ! (Stations 14 à 17)",
          },
        ],
      },
      {
        id: 2,
        contenus: [
          {
            type: "audio",
            titre: "Audio",
            url: "7670_terminus4_audio_3-1_femme_artisane",
            texte: "3.1 La vie d’une femme artisane",
          },
          {
            type: "video",
            titre: "Vidéo",
            url: "775859642",
            texte: "3.1 Des objets du quotidien",
          },
          {
            type: "interactif",
            titre: "Clic info !",
            url: "https://www.iplusinteractif.com/dapps/criterie/109/",
            texte: "3.1 Des mots empruntés aux&nbsp;langues autochtones",
          },
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_3-2/Activity/",
            texte: "3.2 Halte ! (Stations 18 à 20)",
          },
        ],
      },
    ],
  },
  {
    id: 4,
    titre: "Expédition <span class='chapter-number'>4</span>",
    sousTitre:
      "Les <span class='chapter-emphasis'>Treize colonies</span> vers 1745",
    pauses: [
      {
        id: 1,
        contenus: [
          {
            type: "video",
            titre: "Vidéo",
            url: "796988156",
            texte: "4.1 Les plantations",
          },
          {
            type: "interactif",
            titre: "Clic info !",
            url: "https://www.iplusinteractif.com/dapps/criterie/115/",
            texte: "4.1 La culture du coton aujourd’hui",
          },
          {
            type: "activite",
            titre: "Activité interactive",
            url: "https://www.iplusinteractif.com/dapps/activities/avec-retro/7670_terminus4_AI_4_1/Activity/",
            texte: "4.1 Halte ! (Stations 21 à 24)",
          },
        ],
      },
    ],
  },
];
